import { render, staticRenderFns } from "./sensordetail.vue?vue&type=template&id=0e6a5b7d&scoped=true&class=geofence-mainview&"
import script from "./sensordetail.vue?vue&type=script&lang=js&"
export * from "./sensordetail.vue?vue&type=script&lang=js&"
import style0 from "./sensordetail.vue?vue&type=style&index=0&id=0e6a5b7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6a5b7d",
  null
  
)

export default component.exports